import useBundleTranslation from 'i18n';
import Moment from 'moment/moment';
import { FormDataAPIType } from 'components/common/form';
import { DatasetInstance } from 'components/dataset-viewer';
import { Box, Stack } from '@mui/material';
import { TemplateFormComponent } from 'components/common/form/layout/ReactHookFormController';
import { StaticAddon } from 'components/common/static-addon/StaticAddon';

export default function GenerateAlertEventsForm({
    elementProps,
    datasetInstances,
    withHistory,
    dateOnly = false,
}: {
    elementProps: FormDataAPIType;
    datasetInstances: DatasetInstance[];
    withHistory: boolean;
    dateOnly?: boolean;
}) {
    const { t } = useBundleTranslation(['components/report-content', 'app/report/report-alert-rule']);
    const generateAlertEvents = elementProps.form.hookFormWatch('generate_alert_events');
    const dateFromValue: string | null = elementProps.form.hookFormWatch('date_from');
    const dateToValue: string | null = elementProps.form.hookFormWatch('date_to');

    const instanceUnix = datasetInstances.map((i) => Moment(i.measurement_time_raw).unix());
    const overallMin =
        instanceUnix.length > 0 ? Moment.unix(Math.min(...instanceUnix)).format('YYYY-MM-DD') + 'T12:00:00' : undefined;
    const overallMax =
        instanceUnix.length > 0 ? Moment.unix(Math.max(...instanceUnix)).format('YYYY-MM-DD') + 'T12:00:00' : undefined;

    return (
        <Box>
            <Box className={dateOnly ? 'd-none' : ''}>
                <TemplateFormComponent
                    elementProps={elementProps}
                    component={'FormSwitch'}
                    name={'generate_alert_events'}
                    label={t('generate_alert_events')}
                />
            </Box>

            <Stack
                className={generateAlertEvents === 'Y' && withHistory ? '' : 'd-none'}
                direction={'row'}
                spacing={2}
                sx={{ mt: 2 }}
            >
                <Box sx={{ display: 'flex' }}>
                    <StaticAddon>{t('date_from')}</StaticAddon>
                    <TemplateFormComponent
                        elementProps={elementProps}
                        component={'FormDatePicker'}
                        name={'date_from'}
                        props={{
                            minDate: overallMin,
                            maxDate: dateToValue ?? overallMax,
                        }}
                    />
                </Box>
                <Box sx={{ display: 'flex' }}>
                    <StaticAddon>{t('date_to')}</StaticAddon>
                    <TemplateFormComponent
                        elementProps={elementProps}
                        component={'FormDatePicker'}
                        name={'date_to'}
                        props={{
                            minDate: dateFromValue ?? overallMin,
                            maxDate: overallMax,
                        }}
                    />
                </Box>
            </Stack>
        </Box>
    );
}
